import React, { useEffect, useRef, useState } from "react";
import { CorebaseURL, corefetch, corepost } from "../../Util/axios_core_helper";
import {
  Button,
  CommonErrorMsg,
  confirmDelete,
  ErrorMsg,
  sessionUser,
  ValidateForm,
} from "../../Util/common";
import { KendoGrid } from "../../Kendo/kendo_grid";
import { KendoMultiSelect } from "../../Kendo/kendo_multiselect";
import { KendoDropdown } from "../../Kendo/kendo_dropdown";
import { KendoDatePicker } from "../../Kendo/kendo_datepicker";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { onDisplayedInEdit } from "../Amenities/AmenitiesSlice";
import { KendoLoader } from "../../Kendo/kendo_loader";

export const RequestedVendor = () => {
  const [refreshGrid, setrefreshGrid] = useState(0);
  const [editVisible, setEditVisible] = useState(false);
  const [refreshflag, setrefreshflag] = useState(0);

  const [error, setError] = useState({});
  const { selDisplayedInIds } = useSelector((state) => state.Amenities);
  const dispatch = useDispatch();
  const modalRef = useRef(null);
  const [Loading, setLoading] = useState(false);

  const [requestedVendor, setRequestedVendor] = useState({
    vendorId: 0,
    clientName: "",
    vendorName: "",
    eventDate: "",
    ballroomId: 0,
    vendorTypeId: "",
    companyName: "",
    emailID: "",
    phoneNumber: "",
    faceBook: "",
    twitter: "",
    instagram: "",
    tiktok: "",
    youtube: "",
    pinterest: "",
    linkedin: "",
    flickr: "",
    vimeo: "",
    savedBy: "",
    isApproved: false,
  });
  const clearForm = () => {
    setLoading(false);
    $("#hide").click();
    setRequestedVendor({
      vendorId: 0,
      clientName: "",
      vendorName: "",
      eventDate: "",
      ballroomId: 0,
      vendorTypeId: "",
      companyName: "",
      emailID: "",
      phoneNumber: "",
      faceBook: "",
      twitter: "",
      instagram: "",
      tiktok: "",
      youtube: "",
      pinterest: "",
      linkedin: "",
      flickr: "",
      vimeo: "",
      savedBy: "",
    });
    setError({});

    dispatch(onDisplayedInEdit(""));
    const form = document.getElementById("form-culture-config");
    if (form) {
      form.reset();
    }
  };
  const handleEditClick = async (e) => {
    try {
      const response = await corefetch(
        `RequestedVendor/GetRequestedVendorList?id=${e.vendorId}`
      );

      if (response && response.length > 0) {
        dispatch(onDisplayedInEdit(e.vendorTypeId));

        const fetchedData = response[0];
        // const parsedVendorTypeIds = fetchedData?.vendorTypeId
        //   ? fetchedData.vendorTypeId.split(",").map(Number) // Convert to an array of numbers
        //   : [];
        setRequestedVendor({
          vendorId: fetchedData?.vendorId || 0,
          clientName: fetchedData?.clientName || "",
          vendorName: fetchedData?.vendorName || "",
          vendorTypeId: fetchedData?.vendorTypeId || "",
          eventDate: fetchedData?.eventDate || "",
          ballroomId: fetchedData?.ballroomId || 0,
          // vendorTypeId: parsedVendorTypeIds,
          companyName: fetchedData?.companyName || "",
          emailID: fetchedData?.emailID || "",
          phoneNumber: fetchedData?.phoneNumber || "",
          faceBook: fetchedData?.faceBook || "",
          twitter: fetchedData?.twitter || "",
          instagram: fetchedData?.instagram || "",
          tiktok: fetchedData?.tikTok || "",
          youtube: fetchedData?.youtube || "",
          pinterest: fetchedData?.pinterest || "",
          linkedin: fetchedData?.linkedin || "",
          flickr: fetchedData?.flickr || "",
          vimeo: fetchedData?.vimeo || "",
          savedBy: fetchedData?.savedBy || "",
          isApproved: fetchedData?.isApproved || false,
        });
        const modal = new bootstrap.Modal(
          document.getElementById("add_requestedVendor")
        );
        modal.show();
      } else {
        console.error("No data found for the given vendor ID.");
      }
    } catch (error) {
      console.error("Error in API call:", error);
    }
  };
  const handleDropdownChange = (e) => {
    const seletedValue = e ? e : null;
    setRequestedVendor((prevEvents) => ({
      ...prevEvents,
      ballroomId: seletedValue,
    }));
  };
  const handleDropdownChangeVendor = (e) => {
    const selectedValues = e ? e : null;

    setRequestedVendor((prevEvents) => ({
      ...prevEvents,
      vendorTypeId: selectedValues,
    }));
  };

  const onValidation = (name, val) => {
    setError((prvErr) => {
      return {
        ...prvErr,
        [name]:
          !val || (val && val.trim() == "") || (val && val.trim().length == 0),
      };
    });
  };
  const handleDeleteClick = async (e) => {
    const onDelete = () => {
      corefetch(
        `RequestedVendor/DeleteRequestedVendor?id=${
          e.vendorId
        }&deletedBy=${sessionUser()}`,
        true,
        false,
        true
      ).then(() => {
        setrefreshflag(refreshflag + 1);
      });
    };
    confirmDelete(onDelete);
  };
  const handleDateChange = (e) => {
    const selectedDate = e ? e : null;
    if (selectedDate == null) {
      setRequestedVendor((prev) => ({
        ...prev,
        eventDate: null,
      }));
      setError({ ...error, eventDate: true });
    } else {
      setRequestedVendor((prev) => ({
        ...prev,
        eventDate: selectedDate,
      }));
      setError({ ...error, eventDate: false });
    }
  };
  const onSubmit = async (e) => {
    e.preventDefault();

    // Email and URL patterns
    const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    const facebookPattern = /^https:\/\/.*facebook.*$/;
    const twitterPattern = /^https:\/\/.*x.*$/;
    const instagramPattern = /^https:\/\/.*instagram.*$/;
    const tiktokPattern = /^https:\/\/.*tiktok.*$/;
    const linkedinPattern = /^https:\/\/.*linkedin.*$/;
    const youtubePattern = /^https:\/\/.*youtube.*$/;
    const vimeoPattern = /^https:\/\/.*vimeo.*$/;
    const flickrPattern = /^https:\/\/.*flickr.*$/;
    const pinterestPattern = /^https:\/\/.*pinterest.*$/;

    // Check for invalid email
    if (
      !emailPattern.test(requestedVendor.emailID) ||
      requestedVendor.emailID === ""
    ) {
      setError((prevError) => ({ ...prevError, ValidEmail: true }));
      return;
    }

    // Check if any of the URL fields are invalid
    if (
      (requestedVendor.faceBook &&
        !facebookPattern.test(requestedVendor.faceBook)) ||
      (requestedVendor.twitter &&
        !twitterPattern.test(requestedVendor.twitter)) ||
      (requestedVendor.instagram &&
        !instagramPattern.test(requestedVendor.instagram)) ||
      (requestedVendor.tiktok && !tiktokPattern.test(requestedVendor.tiktok)) ||
      (requestedVendor.linkedin &&
        !linkedinPattern.test(requestedVendor.linkedin)) ||
      (requestedVendor.youtube &&
        !youtubePattern.test(requestedVendor.youtube)) ||
      (requestedVendor.vimeo && !vimeoPattern.test(requestedVendor.vimeo)) ||
      (requestedVendor.flickr && !flickrPattern.test(requestedVendor.flickr)) ||
      (requestedVendor.pinterest &&
        !pinterestPattern.test(requestedVendor.pinterest))
    ) {
      setError((prevError) => ({
        ...prevError,
        faceBook:
          requestedVendor.faceBook &&
          !facebookPattern.test(requestedVendor.faceBook)
            ? "Please enter a valid Facebook URL"
            : "",
        twitter:
          requestedVendor.twitter &&
          !twitterPattern.test(requestedVendor.twitter)
            ? "Please enter a valid Twitter URL"
            : "",
        instagram:
          requestedVendor.instagram &&
          !instagramPattern.test(requestedVendor.instagram)
            ? "Please enter a valid Instagram URL"
            : "",
        tiktok:
          requestedVendor.tiktok && !tiktokPattern.test(requestedVendor.tiktok)
            ? "Please enter a valid TikTok URL"
            : "",
        linkedin:
          requestedVendor.linkedin &&
          !linkedinPattern.test(requestedVendor.linkedin)
            ? "Please enter a valid LinkedIn URL"
            : "",
        youtube:
          requestedVendor.youtube &&
          !youtubePattern.test(requestedVendor.youtube)
            ? "Please enter a valid YouTube URL"
            : "",
        vimeo:
          requestedVendor.vimeo && !vimeoPattern.test(requestedVendor.vimeo)
            ? "Please enter a valid Vimeo URL"
            : "",
        flickr:
          requestedVendor.flickr && !flickrPattern.test(requestedVendor.flickr)
            ? "Please enter a valid Flickr URL"
            : "",
        pinterest:
          requestedVendor.pinterest &&
          !pinterestPattern.test(requestedVendor.pinterest)
            ? "Please enter a valid Pinterest URL"
            : "",
      }));
      return; // Prevent submit if any URL is invalid
    }

    // If there are no errors, proceed with submitting the form
    const err = ValidateForm(e);
    if (err) {
      setError(err);
      return;
    }

    setLoading(true);
    const formData = new FormData();

    // Append form data
    formData.append("VendorID", requestedVendor.vendorId || 0);
    formData.append("ClientName", requestedVendor.clientName);
    formData.append(
      "EventDate",
      requestedVendor.eventDate
        ? new Date(requestedVendor.eventDate).toISOString()
        : new Date().toISOString()
    );
    formData.append("BallroomID", requestedVendor.ballroomId || 0);
    formData.append("VendorName", requestedVendor.vendorName);
    formData.append("CompanyName", requestedVendor.companyName);
    formData.append("VendorTypeID", requestedVendor.vendorTypeId);
    formData.append("EmailID", requestedVendor.emailID);
    formData.append("PhoneNumber", requestedVendor.phoneNumber);
    formData.append("Facebook", requestedVendor.faceBook || "");
    formData.append("Twitter", requestedVendor.twitter || "");
    formData.append("Instagram", requestedVendor.instagram || "");
    formData.append("TikTok", requestedVendor.tiktok || "");
    formData.append("LinkedIn", requestedVendor.linkedin || "");
    formData.append("YouTube", requestedVendor.youtube || "");
    formData.append("Vimeo", requestedVendor.vimeo || "");
    formData.append("Flickr", requestedVendor.flickr || "");
    formData.append("Pinterest", requestedVendor.pinterest || "");

    try {
      await corepost(
        "Vendor/InsertUpdateVendorRegister",
        formData,
        true,
        true,
        false,
        false
      );
      setLoading(false);
      setrefreshflag(refreshflag + 1);
      clearForm();
      $("#vendor-cancel").click();
    } catch (error) {
      console.error("Error while submitting the form:", error);
    }
  };

  const refreshChildGrd = () => {
    $(`#reload-eventandfunctions`)
      .next()
      .find(".k-master-row")
      .each(function (index) {
        if ($(this).find("td:first").find("a:first").hasClass("k-i-collapse")) {
          $(this).next().find(".btn-refresh:first").click();
        }
      });
  };
  const handleApproveClick = async (e) => {
    try {
      const response = await corepost(
        `Vendor/ApproveRequestedVendor?vendorId=${e.vendorId}`,
        true,
        false,
        true
      );
      if (response) {
        setrefreshflag(refreshflag + 1);
        toast.success("Approved Successfully!");
      } else {
        throw new Error("Failed to approve vendor");
      }
    } catch (error) {
      console.error("Error approving vendor:", error);
    }
  };

  return (
    <>
      {/* <div className="page-header">
        <div className="row">
          <div className="col-sm-12">
            <h3 className="page-title">Registered Vendor Web</h3>
            <ul className="breadcrumb">
              <li className="breadcrumb-item">
                <a>Configuration</a>
              </li>
              <li className="breadcrumb-item active">Registered Vendor Web</li>
            </ul>
          </div>
        </div>
      </div> */}

      <div className="card bg-white">
        <div className="card-body">
          <div className="col-auto ms-auto">
            <div className="row">
              <div className="col-sm-6"></div>
              <div className="col-auto float-end ms-auto">
                <div className="d-flex justify-content-end mb-2"></div>
              </div>
            </div>

            <div>
              <KendoGrid
                name={"welcomeTo-config"}
                url={CorebaseURL + "RequestedVendor/GetRequestedVendorList"}
                schema={{}}
                columns={[
                  {
                    field: "vendorId",
                    filterable: false,
                    hidden: true,
                  },

                  {
                    field: "vendorName",
                    title: "Vendor Name",
                    width: "150px",
                  },
                  {
                    field: "phoneNumber",
                    title: "Contact No",
                    width: "150px",
                  },
                  {
                    field: "emailID",
                    title: "Email ID",
                    width: "150px",
                  },
                  {
                    field: "isApproved",
                    title: "Status",
                    width: "150px",
                    template: (dataItem) =>
                      dataItem.isApproved ? "Approved" : "Not Approved",
                  },
                ]}
                showOptions={true}
                showEdit={true}
                showDelete={true}
                showApprovalBtn={true}
                onEditClick={(e) => handleEditClick(e)}
                onDeleteClick={(e) => handleDeleteClick(e)}
                onApprovalBtnClick={(e) => handleApproveClick(e)}
                refreshWhen={refreshflag}
                disableExportExcel={true}
                height={"60vh"}
              />
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal custom-modal fade"
        id="add_requestedVendor"
        role="dialog"
        aria-hidden="true"
        data-bs-backdrop="static"
      >
        <div
          className="modal-dialog modal-dialog-centered vendor"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Edit Vendor</h5>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => clearForm()}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <form id="form-culture-config" onSubmit={onSubmit}>
                <div className="row">
                  <div className="col-md-4">
                    <div className="input-block mb-3">
                      <label className="form-label">Client Name</label>
                      <input
                        type="text"
                        name="clientName"
                        className="form-control"
                        value={requestedVendor.clientName}
                        placeholder="Client Name"
                        onChange={(e) => {
                          setRequestedVendor((prev) => ({
                            ...prev,
                            clientName: e.target.value,
                          }));
                          onValidation("clientName", e.target.value); // Real-time validation
                        }}
                      />
                      {/* <CommonErrorMsg
                        text="Client Name is required"
                        IsError={error.clientName}
                      /> */}
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="input-block mb-3">
                      <label className="form-label">Event Date</label>
                      <KendoDatePicker
                        name="eventDate"
                        value={requestedVendor.eventDate}
                        placeholder={"Select Date"}
                        // required={true}
                        format={"MM/dd/yyyy"}
                        onChange={handleDateChange}
                      />
                      {/* <CommonErrorMsg
                        text="Event Date is required"
                        IsError={error.eventDate}
                      /> */}
                      {/* <input
                        type="date"
                        name="eventDate"
                        className="form-control"
                        value={requestedVendor.eventDate}
                        onChange={(e) =>
                          setRequestedVendor({
                            ...requestedVendor,
                            eventDate: e.target.value,
                          })
                        }
                      /> */}
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="input-block mb-3">
                      <label className="form-label">Ballroom Name</label>
                      <KendoDropdown
                        name="ballroomId"
                        url={CorebaseURL + "Facility/GetActiveBallroomData"}
                        placeholder="Select Displayed In..."
                        dataTextField="facilityName"
                        dataValueField="facilityID"
                        value={requestedVendor.ballroomId || ""}
                        // required={true}
                        // onValidate={onValidation}
                        onChange={handleDropdownChange}
                      />
                    </div>
                  </div>
                  <div className="modal-title vendor"> Vendor Information</div>
                  <div className="col-md-4">
                    <div className="input-block mb-3">
                      <label className="form-label">
                        Vendor Name
                        <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        name="vendorName"
                        className="form-control"
                        placeholder="Vendor Name"
                        data-required="true"
                        value={requestedVendor.vendorName}
                        onChange={(e) => {
                          setRequestedVendor((prev) => ({
                            ...prev,
                            vendorName: e.target.value,
                          }));
                          onValidation("vendorName", e.target.value); // Real-time validation
                        }}
                      />
                      <CommonErrorMsg
                        text="Vendor Name is required"
                        IsError={error.vendorName}
                      />
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div className="input-block mb-3">
                      <label className="form-label">
                        Company Name
                        <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        name="companyName"
                        className="form-control"
                        value={requestedVendor.companyName}
                        placeholder="Company Name"
                        data-required="true"
                        onChange={(e) => {
                          setRequestedVendor((prev) => ({
                            ...prev,
                            companyName: e.target.value,
                          }));
                          onValidation("companyName", e.target.value); // Real-time validation
                        }}
                      />
                      <CommonErrorMsg
                        text="Company Name is required"
                        IsError={error.companyName}
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="input-block mb-3">
                      <label className="form-label">
                        Vendor Type
                        <span className="text-danger">*</span>
                      </label>
                      <KendoMultiSelect
                        name="vendorTypeId"
                        url={CorebaseURL + "Vendor/GetVendorTypeNames"}
                        placeholder={"Select Displayed In..."}
                        dataTextField="vendorTypeName"
                        dataValueField="vendorTypeId"
                        value={selDisplayedInIds}
                        // value={requestedVendor.vendorTypeId}
                        required={true}
                        onValidate={onValidation}
                        onChange={handleDropdownChangeVendor}
                        tagMode="multiple"
                      />
                      <CommonErrorMsg
                        text="Vendor Type is required"
                        IsError={error.vendorTypeId}
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="input-block mb-3">
                      <label className="form-label">
                        Email ID
                        <span className="text-danger">*</span>
                      </label>
                      <input
                        type="email"
                        name="emailID"
                        className="form-control"
                        value={requestedVendor.emailID}
                        placeholder="EmailID"
                        data-required="true"
                        onChange={(e) => {
                          setRequestedVendor((prev) => ({
                            ...prev,
                            emailID: e.target.value,
                          }));
                          onValidation("emailID", e.target.value);
                          const emailPattern =
                            /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;

                          if (
                            !emailPattern.test(e.target.value) &&
                            e.target.value != ""
                          ) {
                            setError((prevError) => ({
                              ...prevError,
                              ValidEmail: true,
                            }));
                          } else {
                            setError((prevError) => ({
                              ...prevError,
                              ValidEmail: false,
                            }));
                          }
                        }}
                      />
                      {error.ValidEmail && (
                        <ErrorMsg text="Please provide a valid email address" />
                      )}
                      <CommonErrorMsg
                        text="Email ID is required"
                        IsError={error.emailID}
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="input-block mb-3">
                      <label className="form-label">
                        Phone Number
                        <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        name="phoneNumber"
                        className="form-control"
                        value={requestedVendor.phoneNumber}
                        placeholder="Phone Number"
                        data-required="true"
                        onChange={(e) => {
                          setError((prevError) => ({
                            ...prevError,
                            phoneNumber: false,
                            invalidNo: false,
                          }));

                          let rawValue = e.target.value.replace(/\D/g, ""); // Remove non-numeric characters

                          if (rawValue.length > 10)
                            rawValue = rawValue.substring(0, 10);

                          let formattedValue = "";
                          if (rawValue.length > 3) {
                            formattedValue = `(${rawValue.substring(
                              0,
                              3
                            )}) ${rawValue.substring(3, 6)}${
                              rawValue.length > 6
                                ? "-" + rawValue.substring(6)
                                : ""
                            }`;
                          } else if (rawValue.length > 0) {
                            formattedValue = `(${rawValue}`;
                          }

                          setRequestedVendor((prev) => ({
                            ...prev,
                            phoneNumber: formattedValue,
                          }));
                          if (rawValue.length === 0) {
                            setError((prevError) => ({
                              ...prevError,
                              phoneNumber: true, // Set error for empty phone number
                              invalidNo: false, // Clear the invalid number error
                            }));
                          } else if (rawValue.length < 10) {
                            // If the phone number is not empty but less than 10 digits
                            setError((prevError) => ({
                              ...prevError,
                              invalidNo: true, // Set error for invalid number
                              phoneNumber: false, // Clear the required error
                            }));
                          } else {
                            // Clear all errors if the phone number is valid
                            setError((prevError) => ({
                              ...prevError,
                              phoneNumber: false,
                              invalidNo: false,
                            }));
                          }

                          onValidation("PhoneNumber", formattedValue);
                        }}
                      />
                      {error.invalidNo && (
                        <CommonErrorMsg
                          text="Phone number must be 10 digits"
                          IsError={true}
                        />
                      )}
                      <CommonErrorMsg
                        text="Phone Number is required"
                        IsError={error.phoneNumber}
                      />
                    </div>
                  </div>
                  <div className="modal-title vendor">
                    Social Media Link Details
                  </div>
                  <div className="col-md-4">
                    <div className="input-block mb-3">
                      <label className="form-label">Facebook</label>
                      <input
                        type="text"
                        name="faceBook"
                        className="form-control"
                        placeholder="Enter Facebook URL"
                        value={requestedVendor.faceBook}
                        onChange={(e) => {
                          const facebookPattern = /^https:\/\/.*facebook.*$/;
                          const value = e.target.value;
                          setRequestedVendor({
                            ...requestedVendor,
                            faceBook: value,
                          });
                          setError((prevError) => ({
                            ...prevError,
                            faceBook:
                              value && !facebookPattern.test(value)
                                ? "Please enter a valid Facebook URL"
                                : "",
                          }));
                        }}
                      />
                      {error.faceBook && (
                        <CommonErrorMsg
                          text="Please enter a valid Facebook URL"
                          IsError={error.faceBook}
                        />
                      )}
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div className="input-block mb-3">
                      <label className="form-label">X(Twitter)</label>
                      <input
                        type="text"
                        name="twitter"
                        className="form-control"
                        placeholder="Enter X URL"
                        value={requestedVendor.twitter}
                        onChange={(e) => {
                          const twitterPattern = /^https:\/\/.*x.*$/;
                          const value = e.target.value;
                          setRequestedVendor({
                            ...requestedVendor,
                            twitter: value,
                          });
                          setError((prevError) => ({
                            ...prevError,
                            twitter:
                              value && !twitterPattern.test(value)
                                ? "Please enter a valid X(Twitter) URL"
                                : "",
                          }));
                        }}
                      />
                      {error.twitter && (
                        <CommonErrorMsg
                          text="Please enter a valid X(Twitter) URL"
                          IsError={error.twitter}
                        />
                      )}
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div className="input-block mb-3">
                      <label className="form-label">Instagram</label>
                      <input
                        type="text"
                        name="instagram"
                        className="form-control"
                        placeholder="Enter Instagram URL"
                        value={requestedVendor.instagram}
                        onChange={(e) => {
                          const instagramPattern = /^https:\/\/.*instagram.*$/;
                          const value = e.target.value;
                          setRequestedVendor({
                            ...requestedVendor,
                            instagram: value,
                          });
                          setError((prevError) => ({
                            ...prevError,
                            instagram:
                              value && !instagramPattern.test(value)
                                ? "Please enter a valid Instagram URL"
                                : "",
                          }));
                        }}
                      />
                      {error.instagram && (
                        <CommonErrorMsg
                          text="Please enter a valid Instagram URL"
                          IsError={error.instagram}
                        />
                      )}
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div className="input-block mb-3">
                      <label className="form-label">TikTok</label>
                      <input
                        type="text"
                        name="tiktok"
                        className="form-control"
                        placeholder="Enter TikTok URL"
                        value={requestedVendor.tiktok}
                        onChange={(e) => {
                          const tiktokPattern = /^https:\/\/.*tiktok.*$/;
                          const value = e.target.value;
                          setRequestedVendor({
                            ...requestedVendor,
                            tiktok: value,
                          });
                          setError((prevError) => ({
                            ...prevError,
                            tiktok:
                              value && !tiktokPattern.test(value)
                                ? "Please enter a valid TikTok URL"
                                : "",
                          }));
                        }}
                      />
                      {error.tiktok && (
                        <CommonErrorMsg
                          text="Please enter a valid TikTok URL"
                          IsError={error.tiktok}
                        />
                      )}
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div className="input-block mb-3">
                      <label className="form-label">LinkedIn</label>
                      <input
                        type="text"
                        name="linkedin"
                        className="form-control"
                        placeholder="Enter LinkedIn URL"
                        value={requestedVendor.linkedin}
                        onChange={(e) => {
                          const linkedinPattern = /^https:\/\/.*linkedin.*$/;
                          const value = e.target.value;
                          setRequestedVendor({
                            ...requestedVendor,
                            linkedin: value,
                          });
                          setError((prevError) => ({
                            ...prevError,
                            linkedin:
                              value && !linkedinPattern.test(value)
                                ? "Please enter a valid LinkedIn URL"
                                : "",
                          }));
                        }}
                      />
                      {error.linkedin && (
                        <CommonErrorMsg
                          text="Please enter a valid LinkedIn URL"
                          IsError={error.linkedin}
                        />
                      )}
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div className="input-block mb-3">
                      <label className="form-label">YouTube</label>
                      <input
                        type="text"
                        name="youtube"
                        className="form-control"
                        placeholder="Enter YouTube URL"
                        value={requestedVendor.youtube}
                        onChange={(e) => {
                          const youtubePattern = /^https:\/\/.*youtube.*$/;
                          const value = e.target.value;
                          setRequestedVendor({
                            ...requestedVendor,
                            youtube: value,
                          });
                          setError((prevError) => ({
                            ...prevError,
                            youtube:
                              value && !youtubePattern.test(value)
                                ? "Please enter a valid YouTube URL"
                                : "",
                          }));
                        }}
                      />
                      {error.youtube && (
                        <CommonErrorMsg
                          text="Please enter a valid YouTube URL"
                          IsError={error.youtube}
                        />
                      )}
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div className="input-block mb-3">
                      <label className="form-label">Vimeo</label>
                      <input
                        type="text"
                        name="vimeo"
                        className="form-control"
                        placeholder="Enter Vimeo URL"
                        value={requestedVendor.vimeo}
                        onChange={(e) => {
                          const vimeoPattern = /^https:\/\/.*vimeo.*$/;
                          const value = e.target.value;
                          setRequestedVendor({
                            ...requestedVendor,
                            vimeo: value,
                          });
                          setError((prevError) => ({
                            ...prevError,
                            vimeo:
                              value && !vimeoPattern.test(value)
                                ? "Please enter a valid Vimeo URL"
                                : "",
                          }));
                        }}
                      />
                      {error.vimeo && (
                        <CommonErrorMsg
                          text="Please enter a valid Vimeo URL"
                          IsError={error.vimeo}
                        />
                      )}
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div className="input-block mb-3">
                      <label className="form-label">Flickr</label>
                      <input
                        type="text"
                        name="flickr"
                        className="form-control"
                        placeholder="Enter Flickr URL"
                        value={requestedVendor.flickr}
                        onChange={(e) => {
                          const flickrPattern = /^https:\/\/.*flickr.*$/;
                          const value = e.target.value;
                          setRequestedVendor({
                            ...requestedVendor,
                            flickr: value,
                          });
                          setError((prevError) => ({
                            ...prevError,
                            flickr:
                              value && !flickrPattern.test(value)
                                ? "Please enter a valid Flickr URL"
                                : "",
                          }));
                        }}
                      />
                      {error.flickr && (
                        <CommonErrorMsg
                          text="Please enter a valid Flickr URL"
                          IsError={error.flickr}
                        />
                      )}
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div className="input-block mb-3">
                      <label className="form-label">Pinterest</label>
                      <input
                        type="text"
                        name="pinterest"
                        className="form-control"
                        placeholder="Enter Pinterest URL"
                        value={requestedVendor.pinterest}
                        onChange={(e) => {
                          const pinterestPattern = /^https:\/\/.*pinterest.*$/;
                          const value = e.target.value;
                          setRequestedVendor({
                            ...requestedVendor,
                            pinterest: value,
                          });
                          setError((prevError) => ({
                            ...prevError,
                            pinterest:
                              value && !pinterestPattern.test(value)
                                ? "Please enter a valid Pinterest URL"
                                : "",
                          }));
                        }}
                      />
                      {error.pinterest && (
                        <CommonErrorMsg
                          text="Please enter a valid Pinterest URL"
                          IsError={error.pinterest}
                        />
                      )}
                    </div>
                  </div>
                </div>
                {Loading ? (
                  <KendoLoader className="d-flex justify-content-end align-items-center" />
                ) : (
                  <div className="text-end btn-mt">
                    <Button
                      name={"Cancel"}
                      isCancelButton={true}
                      id="vendor-cancel"
                      dataBsDismiss={"modal"}
                      onClick={clearForm}
                    />

                    <Button name={"Update"} />
                  </div>
                )}
                <button
                  type="button"
                  id="hide"
                  style={{ display: "none" }}
                  data-bs-dismiss={"modal"}
                  onClick={() => {
                    clearForm();
                  }}
                ></button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
